import { render, staticRenderFns } from "./ViewSupplier.vue?vue&type=template&id=7008674e&"
import script from "./ViewSupplier.vue?vue&type=script&lang=js&"
export * from "./ViewSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports